module.exports = __webpack_public_path__ + "static/media/coins.f1b7a5a7.svg";